module.exports = __webpack_public_path__ + "img/octavia-e-butler.f0b9ef9e.png";